const CHAVE = 'teensibp:drafts';

export type RascunhoLocal = {
  token: string;
  email: string;
  nomeAdolescente: string;
  step: number;
  updatedAt: string;
};

/**
 * Guardamos um ARRAY, não um valor único: o mesmo aparelho preenche a ficha de
 * dois filhos, e um objeto só sobrescreveria o primeiro (seção 5).
 */
export function listar(): RascunhoLocal[] {
  try {
    const bruto = localStorage.getItem(CHAVE);
    if (!bruto) return [];
    const lista = JSON.parse(bruto);
    return Array.isArray(lista) ? lista : [];
  } catch {
    // localStorage indisponível (aba anônima, cookies bloqueados) não pode
    // derrubar a tela inicial — a pessoa ainda consegue retomar pela chave.
    return [];
  }
}

export function salvar(rascunho: RascunhoLocal): void {
  try {
    const outros = listar().filter(
      (r) => !mesmaFicha(r, rascunho.email, rascunho.nomeAdolescente),
    );
    localStorage.setItem(CHAVE, JSON.stringify([...outros, rascunho]));
  } catch {
    /* sem localStorage o preenchimento segue, só não há retomada automática */
  }
}

export function remover(token: string): void {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(listar().filter((r) => r.token !== token)));
  } catch {
    /* ignora */
  }
}

function mesmaFicha(r: RascunhoLocal, email: string, nome: string): boolean {
  return (
    r.email.toLowerCase() === email.toLowerCase() &&
    normalizar(r.nomeAdolescente) === normalizar(nome)
  );
}

function normalizar(nome: string): string {
  return nome
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}
